import formMapper from "@mappers/Modules/news/NewsItem.mapper";
import createItemAPI from "@services/News/createNews";
import Create from "@shared/FormTemplates/Create";
import validator from "@validators/Modules/news/news.validate";
import { ReactElement } from "react";
import CreateForm from "./CreateNews";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
